import React from 'react'

import { Form, Col } from '_zari/core'

const FechaFormGroup = ({ text, value, handleChange }) => {
  return (
    <Form.Group>
      <Form.Label text={text} htmlFor={text} md={4} />
      <Col md={8}>
        <Form.InputDate value={value} name={text} id={`fecha${text}`} onChange={handleChange} />
      </Col>
    </Form.Group>
  )
}

export default React.memo(FechaFormGroup)
